import React from "react";
import Reveal from "./Reveal";
import { TrendingUp, KeyRound, Gift, Calendar, Users, MapPin } from "lucide-react";

const benefits = [
  {
    icon: TrendingUp,
    title: "Akce do konce června",
    body: "Tyto ceny platí pouze do 30. června. Po vyčerpání data se voucher vrací na plnou cenu — bez výjimek.",
  },
  {
    icon: KeyRound,
    title: "Prioritní rezervace",
    body: "Přednost před běžnými klienty. Váš termín je vždy dřív než veřejné objednávky.",
  },
  {
    icon: MapPin,
    title: "Dvě pobočky, jedna úroveň",
    body: "Uplatníte ve kterékoli pobočce — Čestlice i Butovice. A brzy i v nových lokalitách.",
  },
  {
    icon: Calendar,
    title: "Platnost 3 roky",
    body: "Využijte voucher ve chvíli, kdy auto péči skutečně potřebuje. Žádný tlak.",
  },
  {
    icon: Users,
    title: "Přenositelný",
    body: "Darujte ho partnerovi, dětem, klientovi. Prémiový dárek, který má reálnou hodnotu.",
  },
  {
    icon: Gift,
    title: "Status prvního okruhu",
    body: "Pozvánky na uzavřené eventy a nové služby dřív, než se dostanou do ceníku.",
  },
];

export const Benefits = () => {
  return (
    <section id="vyhody" data-testid="benefits-section" className="relative py-20 sm:py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-12 gap-y-8 md:gap-10 items-end mb-12 md:mb-16">
          <Reveal className="col-span-12 md:col-span-8">
            <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
              03 — Co získáte navíc
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
              Voucher je víc
              <br />
              <span className="italic text-gold-gradient">než sleva.</span>
            </h2>
          </Reveal>
          <Reveal delay={150} className="col-span-12 md:col-span-4">
            <p className="text-sm sm:text-base text-zinc-400 font-light leading-relaxed">
              Akce končí 30. června. Po tomto datu se ceny vrací na plnou hodnotu —
              tyto podmínky už nezopakujeme.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-white/5 border border-white/5">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <Reveal
                key={b.title}
                delay={i * 80}
                className="bg-[#060606] p-7 sm:p-8 md:p-10 group hover:bg-[#0B0B0B] transition-colors"
              >
                <div data-testid={`benefit-card-${i}`} className="flex flex-col h-full">
                  <Icon className="text-[#D4AF37] mb-6 md:mb-8 transition-transform duration-500 group-hover:scale-110" size={28} strokeWidth={1} />
                  <h3 className="font-display text-xl sm:text-2xl text-white mb-3">{b.title}</h3>
                  <p className="text-sm text-zinc-400 font-light leading-relaxed">{b.body}</p>
                  <div className="mt-6 md:mt-8 pt-5 md:pt-6 border-t border-white/5 text-[10px] tracking-[0.3em] uppercase text-zinc-600">
                    0{i + 1} / 06
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
